'use strict';

const parseAllowedKinds = (maybeAllowedKinds)=>{
    const defaultAllowedKinds = [
        'image',
        'pdf'
    ];
    const allowedKinds = Array.isArray(maybeAllowedKinds) ? maybeAllowedKinds : defaultAllowedKinds;
    return allowedKinds == null ? void 0 : allowedKinds.map((kind)=>{
        switch(kind){
            case 'image':
                return 'image/*';
            case 'pdf':
                return 'application/pdf';
            case 'audio':
                return 'audio/*';
            case 'video':
                return 'video/*';
            case 'spreadsheet':
                return 'application/vnd.ms-excel';
            case 'word':
            case 'document':
                return [
                    '.doc',
                    '.docx',
                    'application/msword',
                    'application / vnd.openxmlformats - officedocument.wordprocessingml.document'
                ].join(',');
            case 'presentation':
                return 'application/vnd.ms-powerpoint';
            case 'archive':
                return 'application/zip';
            case 'code':
                return 'text/*';
            default:
                return kind;
        }
    }).filter((v)=>!!v).join(',');
};

module.exports = parseAllowedKinds;
